export class Error {
	status: number;
	message: string;
	tryAgain: boolean;
	fullError: any;

	constructor(status: number, message: string) {
		this.status = status;
		this.message = message;
		this.tryAgain = false;
	}
}



// WEBPACK FOOTER //
// ./src/app/shared/models/error.model.ts